import React from "react";
//#region redux
import { useSelector, useDispatch } from "react-redux";
import { AppState } from "store";
import { ThunkDispatch } from "redux-thunk";
import { boardMembersDataUpdated } from "store/actions/boardMembersDataActions";
//#endregion
//#region types
import { UpdateBoardMembersDataFooterProps } from "models/propTypes/boardMemberPropTypes";
import { ActionButton } from "models/propTypes/commonPropTypes";
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModelExternalCompanyData } from "wint-api-client/dist/types";
//#endregion
//#region components
import { PageFooter } from "components/common";
import { UpdateBoardMembersDataMoreActions } from "components/boardMember";
import { useCompanyService } from "serviceHooks";
//#endregion
//#region utils
import { LocalizationHelperInstance } from "utils/helpers";
//#endregion

const UpdateBoardMembersDataFooter: React.FC<UpdateBoardMembersDataFooterProps> = (props) => {
  const { markAsDoneHandler, isDisabled } = props;
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const companyService = useCompanyService();

  const companyId = useSelector((store: AppState) => store.auth.selectedCompany.id ?? 0);

  const onClickAccept = async () => {
    await submitBoardMembersDataToDoForm();
    onBoardMembersDataUpdated();
  };

  const onBoardMembersDataUpdated = () => {
    dispatch(boardMembersDataUpdated(0));
  };

  const submitBoardMembersDataToDoForm = () => {
    return props.boardMembersDataToDoFormSubmitHandler((values) => {
      const boardMembers: WintSuperkollAPIModelExternalCompanyData.Directors = {
        externalDirectors: values.boardMembers?.map((b) => {
          return {
            name: b.boardMember.name,
            mail: b.mail,
            phoneNumber: b.boardMember.phoneNumber,
            socialSecurityNumber: b.boardMember.socialSecurityNumber,
          };
        }),
      };
      return companyService.updateCompanyBoardMembersDetails(companyId, boardMembers);
    });
  };

  const getActionButtons = (): ActionButton[] => {
    const buttons: ActionButton[] = [];

    buttons.push({
      text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Submit),
      onClick: onClickAccept,
      type: StyleEnums.DisplayType.Success,
      successMessage: TranslationKeys.Common.Approved,
      isDisabled: isDisabled,
    });

    return buttons;
  };

  return (
    <PageFooter
      allowForReadOnlyUsers
      actions={getActionButtons()}
      moreActions={<UpdateBoardMembersDataMoreActions markAsDoneHandler={markAsDoneHandler} />}
      showNavigateBack
      disableSuccessMessages
    />
  );
};

export default UpdateBoardMembersDataFooter;
